/*
 * Copyright (c) 2016-2023 VMware, Inc. All Rights Reserved.
 * This software is released under MIT license.
 * The full license information can be found in LICENSE in the root directory of this project.
 */
import { arrayTail } from '../utils/array.js';
import { setAttributes } from '../utils/dom.js';
import { GlobalStateService } from './global.service.js';
export const CDS_FOCUS_TRAP_DOCUMENT_ATTR = 'cds-focus-trap';
/**
 * FocusTrapTrackerService is a static class that keeps track of the active element with focus trap,
 * in case there are multiple in a given page.
 */
export class FocusTrapTrackerService {
    static getTrapElements() {
        return [...GlobalStateService.state.focusTrapItems];
    }
    static setTrapElements(elements) {
        const htmlEl = document.querySelector('html');
        if (htmlEl !== null) {
            setAttributes(htmlEl, [CDS_FOCUS_TRAP_DOCUMENT_ATTR, elements.length ? '' : false]);
        }
        GlobalStateService.state.focusTrapItems = [...elements];
    }
    static removeTrapElement(element) {
        const currentTrapEls = this.getTrapElements();
        if (currentTrapEls.length < 1) {
            return;
        }
        this.setTrapElements([...this.getTrapElements().filter(e => e.focusTrapId !== element.focusTrapId)]);
    }
    static setCurrent(element) {
        if (!element?.focusTrapId) {
            return;
        }
        this.setTrapElements([...this.getTrapElements().filter(e => e.focusTrapId !== element.focusTrapId), element]);
    }
    static activatePreviousCurrent() {
        this.setTrapElements([...this.getTrapElements()].slice(0, -1));
    }
    static getCurrent() {
        return arrayTail(this.getTrapElements()) || null;
    }
}
